import axios from "axios";
import Cookies from "js-cookie";
import config from "../config.js";

const api = config.apiBaseUrl;

const getHeaders = (token) => {
  const activeToken = token || Cookies.get("token") || localStorage.getItem("token");
  if (!activeToken) {
    throw new Error("Missing or invalid Authorization header");
  }
  return { Authorization: `Bearer ${activeToken}` };
};

export const fetchPackingMaterials = async (token) => {
  const response = await axios.get(`${api}/api/packing-materials`, { headers: getHeaders(token) });
  return response.data.materials || [];
};

export const createPackingMaterial = async (token, payload) => {
  const response = await axios.post(`${api}/api/packing-materials`, payload, { headers: getHeaders(token) });
  return response.data.material;
};

export const fetchBatches = async (token) => {
  const response = await axios.get(`${api}/api/packing-material-batches`, { headers: getHeaders(token) });
  return response.data.batches || [];
};

export const receiveStock = async (token, payload) => {
  const response = await axios.post(`${api}/api/packing-material-batches`, payload, { headers: getHeaders(token) });
  return response.data;
};

export const fetchMovements = async (token) => {
  const response = await axios.get(`${api}/api/packing-material-movements`, { headers: getHeaders(token) });
  return response.data.movements || [];
};

export const fetchAuditLogs = async (token) => {
  const response = await axios.get(`${api}/api/packing-material-audit`, { headers: getHeaders(token) });
  return response.data.auditLogs || [];
};

export const fetchInventorySummary = async (token) => {
  const response = await axios.get(`${api}/api/packing-material-reports/summary`, { headers: getHeaders(token) });
  return response.data.summary || {};
};

export const fetchLowStockAlerts = async (token) => {
  const response = await axios.get(`${api}/api/packing-material-reports/low-stock`, { headers: getHeaders(token) });
  return response.data.alerts || [];
};
